import { render, staticRenderFns } from "./WorkPasswordField.vue?vue&type=template&id=ddd0b1e4&scoped=true"
import script from "./WorkPasswordField.vue?vue&type=script&lang=js"
export * from "./WorkPasswordField.vue?vue&type=script&lang=js"
import style0 from "./WorkPasswordField.vue?vue&type=style&index=0&id=ddd0b1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd0b1e4",
  null
  
)

export default component.exports